import React from 'react';
import moment from 'moment';
import { Table } from 'react-bootstrap';
import { formatPhoneNumber } from 'utils';
import { PendingRegisteredOffersListing } from '@bb/domain/dist/types';
import Modal, {
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
} from '../react-common/Modal';

moment.locale('en');

export interface NewOffersModalOffer {
  id: string;
  coop: {
    name: string;
    email: string;
    phone: string;
    org: { name: string; phone: string };
  };
  createdAt: string;
}

export interface NewOffersModalListing {
  line1: string;
  pendingOffers: NewOffersModalOffer[];
}

interface NewOffersModalProps {
  listing: NewOffersModalListing | PendingRegisteredOffersListing;
  show: boolean;
  closeModal: () => void;
}

const NewOffersModal = (props: NewOffersModalProps) => {
  const { listing, show, closeModal } = props;
  return (
    <Modal
      dialogClassName="new-offers-modal"
      show={show}
      onHide={() => closeModal()}
    >
      <ModalHeader>
        <ModalTitle>Offers Pending Notification</ModalTitle>
        {listing.line1}
      </ModalHeader>

      <ModalBody>
        <Table striped bordered hover className="new-offers-modal__table">
          <thead>
            <tr>
              <td>Agent</td>
              <td>Brokerage</td>
              <td>Contact</td>
              <td>Registered</td>
            </tr>
          </thead>
          <tbody>
            {listing.pendingOffers.map(offer => (
              <tr key={offer.id}>
                <td>{offer.coop.name}</td>
                <td>{offer.coop.org.name}</td>
                <td>
                  M: {formatPhoneNumber(offer.coop.phone)}
                  <br />
                  O: {formatPhoneNumber(offer.coop.org.phone)}
                  <br />
                  {offer.coop.email}
                </td>
                <td>{moment(offer.createdAt).format('MMM D, YYYY h:mm A')}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </ModalBody>

      <ModalFooter>
        <button className="btn btn-default" onClick={() => closeModal()}>
          Close
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default NewOffersModal;
